// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__RQjHo","brief":"Item_brief__2UdB-","label":"Item_label__1MuTp","error":"Item_error__1KW9t","icon":"Item_icon__1vzFs"};